import React from 'react';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import PaginationOne from '../../components/pagination/PaginationOne';
import PostStandard from '../../components/post/PostStandard';
import SearchOne from '../../components/widgets/blog/SearchOne';
import CategoryOne from '../../components/widgets/blog/CategoryOne';
import LatestPostOne from '../../components/widgets/blog/LatestPostOne';
import AboutOne from '../../components/widgets/blog/AboutOne';
import TagOne from '../../components/widgets/blog/TagOne';
import InstagramOne from '../../components/widgets/blog/InstagramOne';
import PostData from '../../data/blog/PostData.json';
import FooterOne from '../../common/footer/FooterOne';
import HeaderTwo from '../../common/header/HeaderTwo';
const BlogStandard = ({blogs}) => {
    return (
        <>
            <SEO title="Blogs" />
            <HeaderTwo styles="header-transparent- header-style-2" />
                <BreadcrumbOne 
                    title="Blogs"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Blogs"
                />
                <div className="edu-elements-area edu-section-gap bg-color-white">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-8 eduvibe-blog-standard-wrapper">
                                { 
                                    blogs.slice( 0, 5 ).map((item) => (
                                        <div className="edu-blog blog-type-1 radius-small eduvibe-post-standard mt--40" key={ item.id }>
                                            <PostStandard data={item} />
                                        </div>
                                    ) )
                                }
                                <div className="row">
                                    <div className="col-lg-12 mt--60">
                                        <PaginationOne />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <aside className="edu-blog-sidebar">
                                    <SearchOne />
                                    <CategoryOne extraClass="mt--40" />
                                    <LatestPostOne extraClass="mt--40" />
                                    <AboutOne extraClass="mt--40" />
                                    <TagOne extraClass="mt--40" />
                                    <InstagramOne extraClass="mt--40" />
                                </aside>
                            </div>
                        </div>
                    </div>
                </div>
            <FooterOne />
        </>
    )
}

export default BlogStandard;